import { ScopeName } from './Scope';

const TranslationAboutPage = {
  [`${ScopeName}.title`]: 'Página Sobre',
  [`${ScopeName}.content`]: 'Conteúdo da Página Sobre',
};

export default TranslationAboutPage;
